import { Emoji, MoodEmpty, MoodSad } from "@livechat/design-system-icons";
import { DesignToken, IconSource } from "@livechat/design-system-react-components";

import { Rating } from "interfaces/entities/ticket";
import { withVar } from "themes/helpers";

export const ratingToIconMap: Record<Rating, IconSource> = {
  [Rating.Good]: Emoji,
  [Rating.Neutral]: MoodEmpty,
  [Rating.Bad]: MoodSad,
};

export const ratingToColorMap: Record<Rating, string> = {
  [Rating.Good]: withVar(DesignToken.ActionPositiveDefault),
  [Rating.Neutral]: withVar(DesignToken.ActionWarningDefault),
  [Rating.Bad]: withVar(DesignToken.ActionNegativeDefault),
};

export const ratingToTextMap: Record<Rating, string> = {
  [Rating.Good]: "Great",
  [Rating.Neutral]: "Okay",
  [Rating.Bad]: "Not good",
};
